import { useModel } from "@bcm-dev/bcms-vite";
import ChatPage from "../ChatPage";
import FullScreenChatPage from "../FullScreenChatPage";

/**
 * @function ChatLandingPage
 * @return {React.Component}
 * @exported true
 * @description A landing page for the "/chat" route since there are brandable versions of this page.
 * These pages currently function similarly, although not entirely the same.
 */
export default function ChatLandingPage(props) {
    const { branding } = useModel();
    const options = branding.options || {};
    const chatVersion = options.chat_version_abi22 === "undefined" ? "Chat Box" : options.chat_version_abi22;
    const Component = chatVersion === "Chat Box" ? ChatPage : FullScreenChatPage;
    return <Component { ...props } />;
}